require('./bootstrap');
import router from './router';
import store from './store';


const app = new Vue({
	el: '#app',
	store,
	router,
	created() {
		store.dispatch('clearStore');
	}
});
